"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var LIST_TAG_NAME = new Set([
    'OL',
    'UL'
]);
var QuillConverter = /** @class */ (function () {
    function QuillConverter(editablePptxsUtils) {
        this.editablePptxsUtils = editablePptxsUtils;
    }
    /**
     * @param quillEditor '.ql-editor' Element
     */
    QuillConverter.prototype.convertQuillEditorToTextLines = function (quillEditor) {
        var _this = this;
        var editorLines = this.getEditorLines(quillEditor);
        var textLines = [];
        editorLines.forEach(function (editorLine, index) {
            var lineElements = [editorLine];
            while (lineElements.length > 0) {
                var element = lineElements.pop();
                if (element) {
                    var isTextNode = element.nodeType === Node.TEXT_NODE;
                    var editableText = element.nodeValue;
                    if (isTextNode && _this.hasTextContent(editableText)) {
                        // Typecast because we know the parentElement exists.
                        var parentElement = element.parentElement;
                        var computedStyle = window.getComputedStyle(parentElement);
                        textLines.push({
                            text: element.nodeValue || '',
                            options: {
                                font_size: _this.editablePptxsUtils.convertFontSize(computedStyle),
                                font_face: _this.editablePptxsUtils.convertFontFace(computedStyle),
                                color: _this.editablePptxsUtils.convertFontColor(computedStyle),
                                bold: _this.editablePptxsUtils.isBold(parentElement, computedStyle),
                                italic: _this.editablePptxsUtils.isItalics(parentElement, computedStyle),
                                underline: _this.editablePptxsUtils.isUnderlined(parentElement, computedStyle),
                                align: _this.editablePptxsUtils.getTextAlign(computedStyle)
                            }
                        });
                    }
                    if (element.hasChildNodes()) {
                        var elementChildren = Array.from(element.childNodes).reverse();
                        lineElements.push.apply(lineElements, elementChildren);
                    }
                }
            }
            // Don't add a newline for the last line.
            if (index < editorLines.length - 1) {
                textLines.push({
                    text: '\n'
                });
            }
        });
        // Officegen does not support generating empty text widgets.
        if (textLines.length === 0) {
            throw Error('quill-converter did not convert any text lines.');
        }
        return textLines;
    };
    /**
     * Returns quill editor "lines". A quill editor line is a top-level HTML
     * Element that when rendered as an editable PPTX have trailing \n.
     */
    QuillConverter.prototype.getEditorLines = function (quillEditor) {
        var editorLines = [];
        var topLevelEditorNodes = Array.from((quillEditor === null || quillEditor === void 0 ? void 0 : quillEditor.children) || []);
        topLevelEditorNodes.forEach(function (topLevelEditorNode) {
            if (LIST_TAG_NAME.has(topLevelEditorNode.tagName)) {
                editorLines.push.apply(editorLines, Array.from(topLevelEditorNode.children));
            }
            else {
                editorLines.push(topLevelEditorNode);
            }
        });
        return editorLines;
    };
    QuillConverter.prototype.hasTextContent = function (text) {
        return lodash_1.default.isString(text) && text.length >= 0;
    };
    QuillConverter.$inject = ['prEditablePptxsUtils'];
    return QuillConverter;
}());
(function (angularModule) {
    angularModule.service('prPptxQuillConverter', QuillConverter);
})(angular.module('qualtrics.pr'));
